import React, { createContext } from "react";
import { PatientProfile } from "src/api/types";
import { MatchParam } from "src/constants/matches";
import { useParams } from "react-router-dom";
import { useGetPatientByIdQuery } from "src/api/services/patientsApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { Skeleton } from "@mui/material";

export const PatientContext = createContext<PatientProfile | undefined>(
  undefined
);

interface Props {
  children: React.ReactNode;
}
const PatientProvider = ({ children }: Props) => {
  const { patientId } = useParams<MatchParam<"PATIENT_ID">>();
  const { data, isLoading } = useGetPatientByIdQuery(
    patientId ? Number(patientId) : skipToken
  );

  if (isLoading) {
    return <Skeleton variant="rectangular" height={82} />;
  }

  return (
    <PatientContext.Provider value={data}>{children}</PatientContext.Provider>
  );
};

export default PatientProvider;
